import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { OnInit } from '@angular/core';
import { StepComponent } from '../../abstract/step.component';
import { formTypes } from '@models/forms/form-field.model';
import { get } from 'lodash';

@Component({
  selector: 'app-form-type',
  templateUrl: './form-type.component.html',
  styleUrls: ['../../../mig-form.component.scss'],
})
export class FormTypeComponent extends StepComponent implements OnInit {
  formData: FormGroup = this.builder.group({
    formType: [null, [Validators.required]],
  });
  submit = false;
  formTypes = formTypes;

  constructor(
    builder: FormBuilder,
    @Inject('MigFormService')
    service: ModelService<MigForm>,
    api: CommonVerbsApiService
  ) {
    super(builder, service, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.service.model) {
      this.formData.patchValue({
        formType: this.service.model.formType,
      });
    }
  }

  get form() {
    return this.formData.controls;
  }

  ngSubmit() {
    this.submit = true;
    if (this.formData.invalid) {
      return;
    } else {
      if (this.model) {
        const type = Number(get(this.formData.getRawValue(), 'formType'));
        if (type) {
          this.model.formType = type;
          this.service.set(this.model);
          this.nextStep.emit();
        }
      }
    }
  }
}
